// startup
// Load entry module and return exports
// This entry module used 'module' so it can't be inlined
var __webpack_exports__ = __webpack_require__("./app_prime1studio_ec/cartridges/app_prime1studio_ec/cartridge/client/default/js/jquery.magnific-popup.min.js");
